import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { toast } from '@/lib/toast'

export function useEmployment() {
  return useQuery({
    queryKey: ['my-employment'],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) return []
      const { data, error } = await supabase.from('resident_employment')
        .select('*').eq('resident_id', session.user.id).order('start_date', { ascending: false })
      if (error) throw error
      return data ?? []
    },
  })
}

export function useCreateEmployment() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (input: Record<string, unknown>) => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) throw new Error('Not authenticated')
      const { error } = await supabase.from('resident_employment').insert({ ...input, resident_id: session.user.id })
      if (error) throw error
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['my-employment'] }); toast.success('Saved') },
    onError: (err: Error) => toast.error(err.message),
  })
}

export function useUpdateEmployment() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, ...fields }: Record<string, unknown> & { id: string }) => {
      const { error } = await supabase.from('resident_employment').update(fields).eq('id', id)
      if (error) throw error
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['my-employment'] }); toast.success('Saved') },
    onError: (err: Error) => toast.error(err.message),
  })
}

export function useDeleteEmployment() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.from('resident_employment').delete().eq('id', id)
      if (error) throw error
    },
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['my-employment'] }); toast.success('Removed') },
    onError: (err: Error) => toast.error(err.message),
  })
}
